<template>
  <div class="badge" :class="`-${variant}`">{{ text }}</div>
</template>

<script>
const status = {
  done: {
    variant: 'success',
    text: 'Concluída',
  },
  processing: {
    variant: 'info',
    text: 'Em processamento',
  },
  expired: {
    variant: 'warning',
    text: 'Expirada',
  },
  error: {
    variant: 'danger',
    text: 'Erro',
  },
};

export default {
  name: 'StatusBadge',

  props: {
    status: {
      required: true,
      type: String,
    },
  },

  computed: {
    variant() {
      return status[this.status] ? status[this.status].variant : this.status;
    },

    text() {
      return status[this.status] ? status[this.status].text : this.status;
    },
  },
};
</script>

<style scoped>

</style>
